<span class="loader-inline-spinner">
  <mat-spinner
    [diameter]="diameter"
    [color]="color"
    [value]="value"
  ></mat-spinner>
</span>
